export default __webpack_public_path__ + "static/media/blockwalletIcon.7b4f72af.svg";